import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

interface UploadFilesProps {
  onAcceptFile: Function,
  acceptFiles: string[],
  message?: string,
  messageStrong?: string;
}

const UploadFiles: React.FC<UploadFilesProps> = ({onAcceptFile, acceptFiles, message, messageStrong}) =>  {
  const onDrop = useCallback(acceptFiles => {
    onAcceptFile(acceptFiles);
  }, []);

  const {getRootProps, getInputProps, isDragActive} = useDropzone({accept: acceptFiles , onDrop})

  return(
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {
        <p><span style={{ fontWeight: 'bold', color: '#F00', cursor: 'pointer'}}>{ messageStrong }</span> { message} </p>
      }
      <div>

      </div>
    </div>
  )
}

export default UploadFiles;
